import { render, staticRenderFns } from "./TeacherKYCById.vue?vue&type=template&id=29ae95dd&"
import script from "./TeacherKYCById.vue?vue&type=script&lang=js&"
export * from "./TeacherKYCById.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports